import {
  InspectorControls as BlockInspectorControls,
  __experimentalColorGradientSettingsDropdown as ColorGradientSettingsDropdown,
  __experimentalUseMultipleOriginColorsAndGradients as useMultipleOriginColorsAndGradients,
  useSettings,
} from '@wordpress/block-editor';
import {
  PanelBody,
  RangeControl,
  SelectControl,
  ToggleControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import { fromColorPreset, toColorPreset } from '../../utils/helpers';
import { PIN_POSITIONS } from './pin-positions';

export default function InspectorControls({ attributes, setAttributes, clientId }) {
  const { rotate, showPin, pinColor, pinPosition } = attributes;

  const colorGradientSettings = useMultipleOriginColorsAndGradients();
  const [palette = []] = useSettings('color.palette');

  return (
    <>
      <BlockInspectorControls>
        <PanelBody title={__('Note', 'brandy-blocks')}>
          <RangeControl
            __nextHasNoMarginBottom
            label={__('Tilt', 'brandy-blocks')}
            help={__('Rotation in degrees. Small values read as hand-placed; large ones look like a mistake.', 'brandy-blocks')}
            value={rotate}
            onChange={(value) => setAttributes({ rotate: value ?? 0 })}
            min={-6}
            max={6}
            step={0.5}
            allowReset
            resetFallbackValue={0}
          />

          <ToggleControl
            __nextHasNoMarginBottom
            label={__('Show pin', 'brandy-blocks')}
            checked={showPin}
            onChange={(value) => setAttributes({ showPin: value })}
          />

          {showPin && (
            <SelectControl
              __nextHasNoMarginBottom
              label={__('Pin position', 'brandy-blocks')}
              value={pinPosition}
              options={PIN_POSITIONS}
              onChange={(value) => setAttributes({ pinPosition: value })}
            />
          )}
        </PanelBody>
      </BlockInspectorControls>

      {showPin && (
        <BlockInspectorControls group="color">
          <ColorGradientSettingsDropdown
            __experimentalIsRenderedInSidebar
            settings={[
              {
                label: __('Pin', 'brandy-blocks'),
                // Round-trip through the preset helpers so a palette pick is
                // stored as `var:preset|color|<slug>` — the shape render.php
                // sanitizes. A raw hex from the custom picker passes through.
                colorValue: fromColorPreset(pinColor, palette) || undefined,
                onColorChange: (value) =>
                  setAttributes({ pinColor: toColorPreset(value, palette) ?? '' }),
              },
            ]}
            panelId={clientId}
            {...colorGradientSettings}
          />
        </BlockInspectorControls>
      )}
    </>
  );
}
